import * as React from 'react';
import { PaymentOut } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';

/**
 * PaymentOut Search Page
 *
 * Search and list outbound payment records (read-only)
 */
export const PaymentOutSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(PaymentOut);
  const gCacheQueryItem = useCacheQuery(PaymentOut, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={PaymentOut} />
      <Section>
        <PaginatorAndListSettings
          entity={PaymentOut}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
